import { post, get } from '@/lib/api/client'
import {
  PaginationParamsSchema,
  MemberCountryFilterParamsSchema,
  type MemberCountry,
  type MemberCountryFilterParams,
  type ApiResponse,
  type PaginatedResponse,
  type PaginationParams
} from '@/lib/api/types'

export class MemberCountryService {
  /**
   * Filter countries with pagination (Public endpoint)
   * POST /countries/public/filter?page={page}&size={size}
   */
  async getMemberCountries(
    params: PaginationParams = { page: 1, size: 100 },
    filters: MemberCountryFilterParams = {}
  ): Promise<ApiResponse<PaginatedResponse<MemberCountry>>> {
    const validatedParams = PaginationParamsSchema.parse(params)
    const validatedFilters = MemberCountryFilterParamsSchema.parse(filters)

    const query = new URLSearchParams({
      page: validatedParams.page.toString(),
      size: validatedParams.size.toString()
    }).toString()

    return await post<ApiResponse<PaginatedResponse<MemberCountry>>>(
      `countries/public/filter?${query}`,
      validatedFilters
    )
  }

  /**
   * Get countries by region tag
   * POST /countries/public/filter with regionTag filter
   */
  async getMemberCountriesByRegion(
    regionTag: string,
    params: PaginationParams = { page: 1, size: 100 }
  ): Promise<ApiResponse<PaginatedResponse<MemberCountry>>> {
    return this.getMemberCountries(params, {
      regionTag
    })
  }

    /**
     * Get all member countries (Public endpoint)
     * GET /member-countries/public/all
     */

  async getAllMemberCountries(): Promise<ApiResponse<MemberCountry[]>> {
    return await get<ApiResponse<MemberCountry[]>>(
      `member-countries/public/all`
    )
  }
}

export const memberCountryService = new MemberCountryService()


